import { useEffect, useState } from 'react';
import { Badge, Button, Switch } from '@mui/material';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import _ from 'lodash';

const NewRoomFilterButton = (props) => {
    const { children, onChange } = props;
    const [openModal, setOpenModel] = useState(false);
    const [buildingBadgeCount, setBuildingBadgeCount] = useState(null);
    const [isNewRoomsOnly, setIsNewRoomsOnly] = useState(false);

    const router = useRouter();
    const { query } = router;

    useEffect(() => {
        getNewRoomParamFromQuery();
    }, [query]);

    const getNewRoomParamFromQuery = () => {
        const newRoomParam = _.get(query, 'new');
        if (newRoomParam) {
            const boolVal = newRoomParam == 'true';
            setIsNewRoomsOnly(boolVal);
            boolVal === true ? setBuildingBadgeCount(1) : setBuildingBadgeCount(0);
        }else {
            setIsNewRoomsOnly(false);
            setBuildingBadgeCount(null);
        }
    };

    const onFilterClick = () => {
        setOpenModel(true);
    };

    const onModalClose = () => {
        setOpenModel(false);
    };

    const onToggleChange = (e) => {
        setIsNewRoomsOnly(e.target.checked);

        if (onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <div className='new-room-filter-container'>
            <Button
                id="new-room-filter-button"
                badge={buildingBadgeCount > 0 ? buildingBadgeCount : 0}
                className={buildingBadgeCount > 0 ? 'new-room-filter-badge' : 'new-room-filter-no-badge'}
                onClick={onFilterClick}
            >
                <Badge badgeContent={buildingBadgeCount}>
                    {children}
                </Badge>
            </Button>
            {openModal && (
                <div>
                    <div className='new-room-filter-overlay' onClick={onModalClose} />
                    <div className='new-room-filter-button-modal-container'>
                        <div id="new-room-filter-button-switch-container" className='new-room-filter-button-switch-container'>
                            <h6>All </h6>
                            <Switch
                                checked={isNewRoomsOnly}
                                onChange={onToggleChange}
                                name="new-room"
                                slotProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <h6>New </h6>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

NewRoomFilterButton.propTypes = {
    children: PropTypes.string,

    onChange: PropTypes.func,
};

export default NewRoomFilterButton;
